/* eslint-disable */
import "react-app-polyfill/ie9" // For IE 9-11 support
import "react-app-polyfill/ie11" // For IE 11 support
import "./polyfill"

import { Security } from "@okta/okta-react"
import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter, useHistory } from "react-router-dom"
import { OktaAuth } from "@okta/okta-auth-js"
import extension, { ExtensionContext } from "extensions"
import withStore from "./utils/hocs/withStore"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import ChartDataLabels from "chartjs-plugin-datalabels"
import Chart from "chart.js"
import { AccountContextProvider } from "components/common/Context/AccountContext"
import { MediaContextProvider } from "components/common/Context/MediaContext"
import { ToasterContextProvider } from "components/common/Context/ToasterContext"
import { CurrencyContextProvider } from "components/common/Context/CurrencyContext"
import { FeedbackDrawerContextProvider } from "components/common/Context/FeedbackDrawerContext"
import { DownloadPageContextProvider } from "components/common/Context/DownloadPageContext"
import { ThemeContextProvider } from "components/common/Context/ThemeContext"

function useLoadedExtension() {
  const [_extension, setExtension] = React.useState(null)
  Chart.plugins.unregister(ChartDataLabels)
  React.useEffect(() => {
    ;(async () => {
      const loadedExtension = await extension
      setExtension(loadedExtension)
    })()
  }, [])
  return _extension
}

function Root() {
  const history = useHistory()
  const extension = useLoadedExtension()
  const onAuthRequired = React.useCallback(
    () => history.push("/login"),
    [history]
  )

  if (!extension) return null

  // const oktaAuth = new OktaAuth({
  //   ...extension.config.env.oktaConfig,
  //   redirectUri: `${window.location.origin}/login/callback`,
  //   postLogoutRedirectUri: `${window.location.origin}/login`,
  // });
  return (
    // <Security oktaAuth={oktaAuth} onAuthRequired={onAuthRequired}>
    <ThemeContextProvider>
      <ExtensionContext.Provider value={extension}>
        <MediaContextProvider>
          <ToasterContextProvider>
            <AccountContextProvider>
              <CurrencyContextProvider>
                <FeedbackDrawerContextProvider>
                  <DownloadPageContextProvider>
                    <App />
                  </DownloadPageContextProvider>
                </FeedbackDrawerContextProvider>
              </CurrencyContextProvider>
            </AccountContextProvider>
          </ToasterContextProvider>
        </MediaContextProvider>
      </ExtensionContext.Provider>
    </ThemeContextProvider>
    // </Security>
  )
}
ReactDOM.render(
  React.createElement(
    withStore(
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    )
  ),
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
